/**
 * Newsletter popup facade: load CSS/JS only after the configured delay
 * (or immediately for URL bypass). Skip entirely when the dismiss cookie exists.
 */
(() => {
  const dialog = document.getElementById("newsletter-popup-modal");
  if (!dialog) return;

  const popup = dialog.querySelector("#newsletter-popup");
  const cssHref = dialog.dataset.facadeCss;
  const jsSrc = dialog.dataset.facadeJs;
  if (!popup || !cssHref || !jsSrc) return;

  const delayMs = Number(popup.dataset.configDelay || 5) * 1000;
  const daysToWait = Number(popup.dataset.configDaysToWait || 3);
  const path = popup.dataset.configPath || "newsletter-popup";
  const forceOpen = window.location.href.includes(path);
  const hasCookie = document.cookie.indexOf("ks-newsletter-popup") !== -1;

  if (hasCookie && !forceOpen) return;

  const loadStylesheet = (href) => {
    if (document.querySelector(`link[href="${href}"]`)) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.onload = () => resolve();
      link.onerror = reject;
      document.head.appendChild(link);
    });
  };

  const loadScript = (src) => {
    if (document.querySelector(`script[src="${src}"]`)) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve();
      script.onerror = reject;
      document.head.appendChild(script);
    });
  };

  const createCookie = (name, value, days) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  };

  const openPopup = async () => {
    if (dialog.dataset.facadeBound === "true") return;
    dialog.dataset.facadeBound = "true";

    try {
      await Promise.all([loadStylesheet(cssHref), loadScript(jsSrc)]);
      await customElements.whenDefined("newsletter-popup");

      if (!forceOpen) {
        createCookie("ks-newsletter-popup", true, daysToWait);
      }

      if (typeof dialog.showModal === "function" && !dialog.open) {
        dialog.showModal();
      }
    } catch (error) {
      console.error("Newsletter popup facade failed to load", error);
      dialog.dataset.facadeBound = "false";
    }
  };

  if (forceOpen) {
    setTimeout(openPopup, 500);
    return;
  }

  setTimeout(openPopup, delayMs);
})();
